/* Officer Tatum — AJ layout theme JS (no dependencies) */
(function () {
  'use strict';
  var money = function (cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amt.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- Ajax add-to-cart (cards + PDP) ---------- */
  function toast(msg) {
    var t = document.getElementById('CartToast'); if (!t) return;
    t.querySelector('span').textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 3500);
  }
  function refreshCartCount() {
    fetch(window.theme.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.items.reduce(function (n, i) { return n + (i.handle === "tatum-secured-shipping-insurance" ? 0 : i.quantity); }, 0); });
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]'); if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(window.theme.cartAddUrl + '.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item.status) { toast(item.description || 'Could not add to cart'); return; }
        refreshCartCount(); if (!window.TatumCart || !window.TatumCart.open()) toast('Added: ' + item.product_title);
      })
      .catch(function () { toast('Could not add to cart'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- Smart header: slides away on scroll-down, back on scroll-up (phones) ---------- */
  (function () {
    var hdr = document.querySelector('.site-header'); if (!hdr) return;
    if (hdr.parentElement && hdr.parentElement.classList.contains('shopify-section')) hdr.parentElement.classList.add('is-sticky-wrap');
    var last = window.scrollY, ticking = false;
    function onScroll() {
      var y = window.scrollY, small = window.innerWidth <= 768;
      if (!small) { hdr.classList.remove('is-hidden'); last = y; return; }
      if (y > last + 6 && y > 160 && !document.querySelector('.search-suggest:not([hidden])')) hdr.classList.add('is-hidden');
      else if (y < last - 6 || y <= 160) hdr.classList.remove('is-hidden');
      last = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { onScroll(); ticking = false; }); } }, { passive: true });
    document.addEventListener('focusin', function (e) { if (hdr.contains(e.target)) hdr.classList.remove('is-hidden'); });
  })();

  /* ---------- Header: search + mobile drawer ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]'); if (!t) return;
    var target = document.querySelector(t.getAttribute('data-toggle')); if (!target) return;
    target.classList.toggle('active');
    if (target.classList.contains('active')) { var inp = target.querySelector('input'); if (inp) inp.focus(); }
  });

  /* ---------- Predictive search (Shopify /search/suggest.json) ---------- */
  document.querySelectorAll('form[data-predictive]').forEach(function (form) {
    var input = form.querySelector('input[type="search"]'); var box = form.querySelector('.search-suggest'); if (!input || !box) return;
    var timer, last = '', active = -1;
    var KEEP = ['USA','MAGA','ICE','NASA','CK','FLOTUS','DJT','GGY6','TV','FAFO','CDL','DOGE','YHWH','2GNDRS'];
    function cleanTitle(t) {
      t = String(t).replace(/\s+/g, ' ').replace(/Pannel/gi, 'Panel').replace(/T-?shirts?/gi, 'T-Shirt').replace(/Tshirts?/gi, 'T-Shirt').trim();
      return t.split(' ').map(function (w, i) { var up = w.toUpperCase().replace(/[,.!]/g, ''); if (w === 'T-Shirt') return w; if (KEEP.indexOf(up) > -1) return up; if (/[:\-]/.test(w) && w.length > 1) return w; if (i > 0 && /^(of|the|a|an|and|in|on|for|to|with|at|by|or|vs)$/i.test(w)) return w.toLowerCase(); return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' ');
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function render(q, products) {
      if (!products.length) { box.innerHTML = '<div class="ss-empty">No matches for “' + esc(q) + '”</div>'; box.hidden = false; return; }
      box.innerHTML = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
        return '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') + '<span>' + esc(cleanTitle(p.title)) + '</span><span class="ss-price">' + esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></a>';
      }).join('') + '<a class="ss-all" href="' + form.action + '?q=' + encodeURIComponent(q) + '">See all results →</a>';
      box.hidden = false; active = -1;
    }
    function lookup() {
      var q = input.value.trim(); if (q.length < 2) { box.hidden = true; return; } if (q === last) return; last = q;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) { render(q, (d.resources && d.resources.results && d.resources.results.products) || []); })
        .catch(function () { box.hidden = true; });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(lookup, 180); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && box.innerHTML) box.hidden = false; });
    input.addEventListener('keydown', function (e) {
      var items = box.querySelectorAll('a'); if (box.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length; items.forEach(function (a, k) { a.classList.toggle('is-active', k === active); }); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); location.href = items[active].href; }
      else if (e.key === 'Escape') { box.hidden = true; }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
  });

  /* ---------- "Also in this design" (product page) ---------- */
  document.querySelectorAll('[data-design-family]').forEach(function (sec) {
    var stem = (sec.getAttribute('data-stem') || '').trim(); var me = sec.getAttribute('data-handle'); var row = sec.querySelector('.design-family-row');
    if (!stem || stem.length < 3) return;
    var KILL = /\b(t-?shirts?|tshirts?|tee|hoodie|crewneck|sweatshirt|5-?pannel|5-?panel|snapback|hat|cap|tumbler|bottle|coaster|sticker|active|stainless steel|yard sign|license plate frame|wristband|\d+oz)\b/gi;
    function stemOf(t) { return String(t).toLowerCase().replace(KILL, ' ').replace(/\s+/g, ' ').trim(); }
    function typeOf(t) { var m = String(t).match(/hoodie|crewneck|sweatshirt|hat|snapback|cap|tumbler|bottle|coaster|sticker|t-?shirt|tee/i); var w = m ? m[0].toLowerCase() : ''; if (/t-?shirt|tee/.test(w)) return 'T-Shirt'; return w ? w.charAt(0).toUpperCase() + w.slice(1) : 'Product'; }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    var KEEP = ['USA','MAGA','ICE','NASA','CK','FLOTUS','DJT','GGY6','TV','FAFO','CDL','DOGE','YHWH','2GNDRS'];
    function cleanTitle(t) {
      t = String(t).replace(/\s+/g, ' ').replace(/Pannel/gi, 'Panel').replace(/T-?shirts?/gi, 'T-Shirt').replace(/Tshirts?/gi, 'T-Shirt').trim();
      return t.split(' ').map(function (w, i) { var up = w.toUpperCase().replace(/[,.!]/g, ''); if (w === 'T-Shirt') return w; if (KEEP.indexOf(up) > -1) return up; if (/[:\-]/.test(w) && w.length > 1) return w; if (i > 0 && /^(of|the|a|an|and|in|on|for|to|with|at|by|or|vs)$/i.test(w)) return w.toLowerCase(); return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' ');
    }
    var mine = stemOf(stem);
    // /products.json lists every published product (no 10-result cap like predictive search); 2 pages covers 500 products
    function page(n) { return fetch('/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (d) { return d.products || []; }); }
    Promise.all([page(1), page(2)]).then(function (pages) {
      var all = pages[0].concat(pages[1]);
      var ps = all.filter(function (p) { return p.handle !== me && stemOf(p.title) === mine && p.variants && p.variants.length; });
      if (!ps.length) return;
      row.innerHTML = ps.slice(0, 5).map(function (p) {
        var src = p.images && p.images[0] ? p.images[0].src : '';
        var img = src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var avail = p.variants.some(function (v) { return v.available; });
        var price = p.variants[0].price ? money(Math.round(parseFloat(p.variants[0].price) * 100)) : '';
        var url = '/products/' + p.handle; var type = typeOf(p.title + ' ' + (p.product_type || ''));
        return '<div class="product-card"><div class="product-img-wrap"><a href="' + url + '">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</a><span class="badge new">' + esc(type) + '</span></div><div class="product-info"><p class="product-name"><a href="' + url + '">' + esc(cleanTitle(p.title)) + '</a></p><div class="product-price"><span>' + esc(price) + '</span></div></div><a class="card-atc" href="' + url + '">' + (avail ? 'View ' + esc(type) : 'Sold Out') + '</a></div>';
      }).join('');
      sec.hidden = false;
    }).catch(function () {});
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('.slide'); if (slides.length < 2) return;
    var dots = root.querySelectorAll('.hero-dots button'); var i = 0; var delay = parseInt(root.getAttribute('data-interval') || '6', 10) * 1000; var timer;
    function preload(k) { var im = slides[(k + slides.length) % slides.length].querySelector('img'); if (im && im.loading === 'lazy') { im.loading = 'eager'; } }
    function go(n) {
      var h0 = root.offsetHeight;
      slides[i].classList.remove('active'); if (dots[i]) dots[i].classList.remove('active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('active'); if (dots[i]) dots[i].classList.add('active');
      preload(i + 1);
      var h1 = root.offsetHeight;
      if (h0 && h1 && h0 !== h1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.style.height = h0 + 'px'; root.setAttribute('data-animating', ''); void root.offsetHeight;
        root.style.height = h1 + 'px';
        setTimeout(function () { root.style.height = ''; root.removeAttribute('data-animating'); }, 480);
      }
    }
    function start() { if (delay > 0) timer = setInterval(function () { go(i + 1); }, delay); }
    root.querySelectorAll('.hero-arrow.next').forEach(function (b) { b.addEventListener('click', function () { clearInterval(timer); go(i + 1); start(); }); });
    root.querySelectorAll('.hero-arrow.prev').forEach(function (b) { b.addEventListener('click', function () { clearInterval(timer); go(i - 1); start(); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { clearInterval(timer); go(n); start(); }); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) { clearInterval(timer); go(dx < 0 ? i + 1 : i - 1); start(); } }, { passive: true });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', start);
    preload(1);
    start();
  });

  /* ---------- Product page: variants, qty, gallery ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = document.getElementById(form.getAttribute('data-product-json')); if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var price = document.querySelector('[data-price]'); var compare = document.querySelector('[data-compare]'); var pct = document.querySelector('[data-pct]');
    var atc = form.querySelector('[data-atc]');
    function selected() {
      return product.options.map(function (_, idx) {
        var el = form.querySelector('[data-option-index="' + idx + '"]:checked, select[data-option-index="' + idx + '"]');
        return el ? el.value : null;
      });
    }
    function update() {
      var opts = selected();
      var v = product.variants.find(function (x) { return x.options.every(function (o, idx) { return o === opts[idx]; }); });
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } return; }
      idInput.value = v.id;
      if (price) price.textContent = money(v.price);
      if (compare) { if (v.compare_at_price && v.compare_at_price > v.price) { compare.hidden = false; compare.textContent = money(v.compare_at_price); if (pct) { pct.hidden = false; pct.textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + '% OFF'; } } else { compare.hidden = true; if (pct) pct.hidden = true; } }
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? atc.getAttribute('data-label') : 'Sold Out'; }
      if (v.featured_image && v.featured_image.src) { var main = document.querySelector('[data-main-image]'); if (main) main.src = v.featured_image.src; }
      form.querySelectorAll('[data-option-index]').forEach(function (el) { el.dispatchEvent(new CustomEvent('variant:change', { bubbles: false })); });
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    form.addEventListener('change', function (e) { if (e.target.hasAttribute('data-option-index')) update(); });
    form.querySelectorAll('[data-qty-minus]').forEach(function (b) { b.addEventListener('click', function () { var i = form.querySelector('input[name="quantity"]'); i.value = Math.max(1, parseInt(i.value || '1', 10) - 1); }); });
    form.querySelectorAll('[data-qty-plus]').forEach(function (b) { b.addEventListener('click', function () { var i = form.querySelector('input[name="quantity"]'); i.value = parseInt(i.value || '1', 10) + 1; }); });
    update();
  });
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]'); if (main) main.src = b.getAttribute('data-thumb');
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); }); b.classList.add('active');
    });
  });

  /* ---------- Cart page: qty changes ---------- */
  document.querySelectorAll('[data-line-qty]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      fetch(window.theme.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: inp.getAttribute('data-line-qty'), quantity: parseInt(inp.value, 10) }) })
        .then(function () { return window.TatumCart ? window.TatumCart.refreshPage() : location.reload(); })
        .catch(function () { location.reload(); });
    });
  });

  /* ---------- Cart note quick-fill ---------- */
  document.querySelectorAll('[data-note-quick]').forEach(function (b) {
    b.addEventListener('click', function () { var t = document.getElementById('CartNote'); if (!t) return; if (!t.value.trim()) t.value = b.getAttribute('data-note-quick'); t.focus(); t.setSelectionRange(t.value.length, t.value.length); });
  });
  var noteBox = document.getElementById('CartNote');
  if (noteBox) { var nt; noteBox.addEventListener('input', function () { clearTimeout(nt); nt = setTimeout(function () { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: noteBox.value }) }); }, 500); }); }

  /* ---------- Collection sort ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u; });
  });
})();
